import React, { Component } from "react";
import Question from'./Questionbody.module.css'

export class Questionbody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownVisible: false,
    };
  }

  toggleDropdown = (e) => {
    this.setState((prevState) => ({
      dropdownVisible: !prevState.dropdownVisible,
    }));
  };

  renderDropdown() {
    return (
      <div className="dropdown">
       
        <div className={Question.textbody}>
          <div className={Question.classone}>
            <p >
              Mail notifications are e-mails sent to your e-mail address to
              alert you when you have a new view, a new message, a new
              connection... You can choose if you want to receive them or not.
              It's up to you, but remember: if your connection is visiting your
              profile, you might want to know about it immediately, don't you?
              You can always change your mail notification settings by going to
              Settings. Click the pencil icon next to 'Mail settings' and choose
              your preferred notification settings. Don't forget to save your
              changes!
            </p>
            <br />
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        <div className={Question.trigger}>
          <h3 onClick ={this.toggleDropdown}>
              How can I change the amount of mail notifications I
              receive?
            </h3>
        </div>
        {this.state.dropdownVisible && this.renderDropdown()}
      </div>
    );
  }
}

export default Questionbody;
